import  Vue from 'vue'

export default {
    namespaced: true,
    state: {
        date_active: new Date(),
        type: {
            value: {},
            options: []
        },
        filter: {
            value: {},
            options: []
        },
        open_day: null,
        add_form: false,
        edit_form: false,
        del_course_form: false,
        change_form: false,
        calendarText: {
            month: {},
            week: {},
            weekSmall: {}
        }
    },
    getters: {
        date_active(state){
            return state.date_active;
        },
        day_active_text(state){
            // вернуть текст текущей даты формате 
            return state.date_active.getDate() + ' ' + state.calendarText.month[state.date_active.getMonth()] ;
        },
        date_active_text(state){
            return state.calendarText.month[state.date_active.getMonth()] + ' ' + state.date_active.getFullYear();
        },
        day_in_month(state){
            return state.date_active.daysInMonth();
        },
        days_before(state){
            let new_date = new Date(state.date_active);
            new_date.setDate('1');

            let day_of_week = new_date.getDay();
            if(day_of_week === 0)
                day_of_week = 7;

            return day_of_week - 1;
        },
        days_after(state, getters){
            let remainder = (getters.day_in_month + getters.days_before) % 7;
            if(remainder !== 0)
                return 7 - remainder;
            else
                return 0;
        },
        day_week_header(state){
            let day_week_header = [];
            let index_day = state.date_active.getDay() === 0 ? 7 : state.date_active.getDay();
            let day = state.date_active.getDate();

            day_week_header.push({
                label: state.calendarText.weekSmall[index_day - 1] + day,
                value: state.date_active
            });

            for(let i = 1; i < index_day; i++){
                let new_date = new Date(state.date_active);
                new_date.setDate(new_date.getDate() - i);

                day_week_header.unshift({
                    label: state.calendarText.weekSmall[index_day - 1 - i] + new_date.getDate(),
                    value: new_date
                });
            }

            for(let i = 1; i < (8 - index_day); i++){
                let new_date = new Date(state.date_active);
                new_date.setDate(new_date.getDate() + i);

                day_week_header.push({
                    label: state.calendarText.weekSmall[index_day - 1 + i] + new_date.getDate(),
                    value: new_date
                });
            }

            return day_week_header
        },
        today(state, getters){
            let today = -1;

            let date_active = getters.date_active.getFullYear() + '.' + getters.date_active.getMonth() + '.' + getters.date_active.getDate();
            let date_now = new Date();
            date_now = date_now.getFullYear() + '.' + date_now.getMonth() + '.' + date_now.getDate();

            if(date_now === date_active){
                today =  getters.date_active.getDay();
            }

            if(today === 0)
                today = 7;

            return today
        },
        type(state){
            return state.type
        },
        calendarTypeValue(state){
            return state.type.value;
        },
        filter(state){
            return state.filter
        },
        day_week(state){
            return state.calendarText.week
        },
        day_week_small(state){
            return state.calendarText.weekSmall
        },
        add_form(state){
            return state.add_form;
        },
        open_day(state){
            return state.open_day
        },
        edit_form(state){
            return state.edit_form
        },
        del_course_form(state){
            return state.del_course_form;
        },
        change_form(state){
            return state.change_form
        },
        streams(state){
            return state.streams;
        },
        calendarText(state){
            return state.calendarText;
        }
    },
    mutations: {
        SetType(state, data){
            state.type.value = data;
        },
        SetFilter(state, data){
            state.filter.value = data;
        },
        GoToday(state){
            state.date_active = new Date();
        },
        GoTo(state, data){
            state.date_active = new Date(data);
        },
        PrevMonth(state){
            if(state.type.value.value === 2){
                let new_date = state.date_active;
                new_date.setDate(new_date.getDate()-7);

                state.date_active = new Date(new_date);
            } else{
                let  new_month = state.date_active.getMonth();
                let new_year = state.date_active.getFullYear();
                if(new_month < 1){
                    new_month = 12;
                    new_year--;
                }
                if(new_month < 10)
                    new_month = '0' + new_month;

                state.date_active = new Date(new_year + '-' + new_month + '-01');
            }
        },
        NextMonth(state){
            if(state.type.value.value === 2){
                let new_date = state.date_active;
                new_date.setDate(new_date.getDate()+7);

                state.date_active = new Date(new_date);
            } else{
                let new_month = state.date_active.getMonth() + 2;
                let new_year = state.date_active.getFullYear();
                if(new_month > 12){
                    new_month = 1;
                    new_year++;
                }
                if(new_month < 10)
                    new_month = '0' + new_month;

                state.date_active = new Date(new_year + '-' + new_month + '-01');
            }
        },
        PrevDay(state){
            let new_date = state.date_active;
            new_date.setDate(new_date.getDate()-1);
            state.date_active = new Date(new_date);
        },
        NextDay(state){
            let new_date = state.date_active;
            new_date.setDate(new_date.getDate()+1);
            state.date_active = new Date(new_date);
        },
        OpenAddForm(state){
            state.add_form = true;
        },
        OpenEditForm(state){
            state.edit_form = true;
        },
        OpenDelCourseForm(state){
            state.del_course_form = true;
        },
        OpenChangeForm(state){
            state.change_form = true;
        },
        CloseForm(state){
            state.add_form = false;
            state.edit_form = false;
            state.del_course_form = false;
            state.change_form = false;
        },
        SetOpenDay(state, data){
            state.open_day = data;
        },
        SetStreams(state, data){
            state.streams = data;
        },
        SetCalendarText(state, data){
            state.calendarText = data;
            state.filter.value = {value: 0, label: '1 ' + data.stream};
            // ? что будет если нет первого потока
            state.type = {
                value: {value: 1,label: data.monthTitle},
                options: [
                    {value: 1,label: data.monthTitle},
                    {value: 2,label: data.weekTitle}
                ]
            }
        }
    },
    actions: {
        SetType ({ commit }, data) {
            commit('SetType', data);
        },
        SetFilter ({ commit }, data) {
            commit('SetFilter', data);
        },
        GoTo({ commit }, data) {
            commit('GoTo', data);
        },
        GoToday ({ commit }) {
            commit('GoToday');
        },
        PrevMonth ({commit}) {
            commit('PrevMonth');
        },
        NextMonth ({commit}) {
            commit('NextMonth');
        },
        PrevDay ({commit}) {
            commit('PrevDay');
        },
        NextDay ({commit}) {
            commit('NextDay');
        },
        OpenAddForm ({commit}) {
            commit('OpenAddForm');
        },
        OpenEditForm ({commit}) {
            commit('CloseForm');
            commit('OpenEditForm');
        },
        OpenChangeForm ({commit}) {
            commit('CloseForm');
            commit('OpenChangeForm');
        },
        OpenDelCourseForm ({commit}) {
            commit('CloseForm');
            commit('OpenDelCourseForm');
        },
        SetOpenDay ({commit}, data) {
            commit('CloseForm');
            commit('SetOpenDay', data);
        },
        CloseForm ({commit}) {
            commit('CloseForm');
        },
        LoadStreams ({commit}, data){
            return new Promise((resolve, reject) => {
                Vue.http.get('course/streams.json', {params: data})
                    .then(response => response.json())
                    .then(data => {
                        commit('SetStreams' ,data);
                        resolve();
                    })
            })
        },
        LoadCalendarText ({commit}){
            if(process.env.NODE_ENV !== 'production'){
                return new Promise((resolve, reject) => {
                    Vue.http.get('staticText/calendarText.json')
                        .then(response => response.json())
                        .then(data => {
                            commit('SetCalendarText' ,data);
                            resolve();
                        })
                })
            } else{
                return new Promise((resolve, reject) => {
                    Vue.http.post('staticText', calendarText)
                        .then(response => response.json())
                        .then(data => {
                            commit('SetCalendarText' ,data);
                            resolve();
                        })
                })
            }
        }
    }
};

let calendarText = {
    myApplication: "Моя заявка",
    lesson: "урок",
    placeYes: "Есть места",
    placeNo: "Нет мест",
    lessonEnd: "Урок прошел",
    today: "Сегодня",
    stream: "поток",
    studentArr: ["ученик", "ученика", "учеников"],
    eventArr2: ["занятие", "занятия", "занятий"],
    eventArr: ['событие', 'события', 'событий'],
    applicationArr: ["заявка", "заявки", "заявок"],
    applicationNewArr: ["новая", "новых", "новых"],
    month: ["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],
    month_2: ["января","февраля","марта","апреля","мая","июня","июля","августа","сентября","октября","ноября","декабря"],
    week: ["Понедельник","Вторник","Среда","Четверг","Пятница","Суббота","Воскресенье"],
    weekSmall: ["ПН","ВТ","СР","ЧТ","ПТ","СБ","ВС"],
    monthTitle: "Месяц",
    weekTitle: "Неделя",
    addLessonTitle: "Установка времени",
    addLessonForm: "Начало урока",
    addLessonOtherLessons: "Другие уроки в этот день",
    addLessonBtn: "Сохранить",
    editLesson: "Редактирование",
    deleteStreamTitle: "Удаление потока",
    deleteStream1: "Будет удалён весь поток №",
    deleteStream2: ".\nУдалить?",
    noStreams: 'Нет потоков',
    changeDate: "Изменить дату",
    changeDateLesson: "Дата начала урока",
    change: "Изменить",
    delete: "Удалить",
    cancel: "Отмена"
};



// WEBPACK FOOTER //
// ./src/store/modules/calendar.js